<template>
  <v-dialog
    :value="value"
    persistent
    scrollable
    max-width="600"
    overlay-color="primaryblue"
    :overlay-opacity="0.9"
  >
    <v-card
      class="pre-triage-dialog intro-dark"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="pre-triage-dialog-title"
      aria-describedby="pre-triage-dialog-body"
    >
      <v-sheet tile class="pre-triage-dialog__header" :color="display.color">
        <v-icon size="40" aria-hidden="true">{{ display.icon }}</v-icon>
        <mrx-translation
          id="pre-triage-dialog-title"
          class="pre-triage-dialog__title"
          :token="`triage.${triage}.title`"
        />
        <mrx-translation
          class="pre-triage-dialog__banner"
          :token="`triage.${triage}.banner`"
        />
      </v-sheet>
      <v-card-text id="pre-triage-dialog-body" class="pre-triage-dialog__body">
        <mrx-translation :token="`triage.${triage}.instructions`" />
        <v-divider class="pre-triage-dialog__divider" />
        <mrx-translation token="triage.selection_instructions.title" />
      </v-card-text>
      <v-card-actions class="pre-triage-dialog__actions">
        <v-btn
          class="pre-triage-dialog__acknowledge"
          depressed
          @click="$emit('acknowledge')"
        >
          <mrx-translation token="severities.warning.agreement" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import mrx from '@/mixins/mrx';
import type { Triage } from '../../types/overall-assessment.types';

export default defineComponent({
  name: 'PreTriageDialog',
  mixins: [mrx],

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    triage: {
      type: String as PropType<Triage>,
      required: true,
    },
  },

  computed: {
    display(): { color: string; icon: string } {
      return this.icon(this.triage);
    },
  },
});
</script>

<style scoped src="../../styles/pre-triage-dialog.css"></style>
